
import $ from 'jquery';
import { Provider } from 'react-redux';

import Application from './components/Application';

import { fetchData } from './data';

import store, {
    configure,
    setFilter,
    receivedEntries,
    setFavorites,
    setLoading,
    applyPrefilters,
} from './store';

console.log("[Alpininfo] Starting app");

if ( "production" !== process.env.NODE_ENV ) {
    //require('./style/base.css');
    //require('./style/slider.css');
    //require('./style/checkbox-group.css');
    //require('./style/grid.less');
    //require('./style/results.less');
    //require('./style/overrides.css');
    //require('./style/spinner.css');
}

if ( typeof window.AlpininfoConfig !== "undefined" ) {
    store.dispatch(configure(window.AlpininfoConfig))
}
//window.store = store;
//window.configure = c => store.dispatch(configure(c));

ReactDOM.render(
    <Provider store={store}>
        <Application />
    </Provider>,
    document.getElementById("app")
);


fetchData().then(entries => {
    try {
        let favorites = JSON.parse(localStorage.getItem("alpin:favorites"));
        if ( favorites && favorites.length && favorites.length > 0 ) {
            store.dispatch(setFavorites(favorites));
        }
    }
    catch ( e ) {
        console.error("Failed to load favorites: %s", e);
    }

    store.dispatch(receivedEntries(entries));

    applyPrefilters(store.getState, store.dispatch);

    store.dispatch(setLoading(false));
}).catch(e => console.exception(e));


/* Favoriten lokal speichern */
store.subscribe(() => {
    let state = store.getState();
    localStorage.setItem("alpin:favorites", JSON.stringify(state.favorites));
})


// WEBPACK FOOTER //
// ./main.js